import uuid from 'uuid/v4';

export default function generateAddonId() {
  return uuid();
}